import React, { createContext, forwardRef } from 'react';
import { noop } from '../../utils/noop.esm.js';
import '@popperjs/core';
import { testIdGen } from '../../utils/testIdGen.esm.js';
import { ControlGroup } from '../ControlGroup/ControlGroup.esm.js';

const RadioGroupContext = createContext({
    name: "",
    onChange: noop,
});
/**
 * Group radios together into a field.
 */
const RadioGroup = forwardRef((props, ref) => {
    const { children, dataMetrics, dataTestId, addClassName, disabled, readOnly, onChange, name, value, horizontal, ...rest } = props;
    return (React.createElement(RadioGroupContext.Provider, { value: {
            disabled,
            readOnly,
            name,
            onChange,
            ref,
            value,
        } },
        React.createElement(ControlGroup, { addClassName: addClassName, "data-metrics": dataMetrics, "data-testid": dataTestId || `radio-group-${testIdGen(name)}`, horizontal: horizontal, role: "radiogroup", ...rest }, children)));
});
RadioGroup.displayName = "RadioGroup";

export { RadioGroup, RadioGroupContext };
//# sourceMappingURL=RadioGroup.esm.js.map
